import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Input } from "antd";
import * as tConst from "../../common/Constants";
import { CreateData } from "./data/createDataObjects";
import * as AzureService from "../../api/ticketsApiAzure";

const ChartSprintHeaderMenuAdo = ({ ...props }) => {
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketId, setTicketId] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [newTicketTitle, setNewTicketTitle] = useState("")

  const selectedSprint = props.selectedSprint;

  if (props.showSprintHeaderChartMenu && selectedSprint) {
    return (
      <>
        <Modal show={props.showSprintHeaderChartMenu}>
          <Modal.Header>
            <Modal.Title>
              <h3>Add ticket to sprint {props.selectedSprint.SprintName}</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <div>Ticket ID</div>
            <Input placeholder="Ticket id" value={ticketId} onChange={(event) => { setTicketId(event.target.value) }} style={{ width: 'auto', marginRight: '8px' }} />
            <Button
              onClick={(event) => {
                props.Search(ticketId).then(
                  (response) => {
                    setSelectedTicket(response)
                    console.log("Search Reponse:" + JSON.stringify(response, null, 4))
                  }
                )
              }}
              style={{ marginRight: '8px' }}
            >
              Search
            </Button>
            <Button onClick={() => {setShowNew(!showNew)}}>
              New
            </Button>
            <br/>

            {showNew &&
              <>
              <label>New title</label>&nbsp;
              <Input value={newTicketTitle} onChange={(event) => { setNewTicketTitle(event.target.value) }} style={{ width: 'auto', marginRight: '8px', marginTop: '8px' }} />

              <Button type="primary" onClick={() => {
                const _newItem = {
                  newTitle : newTicketTitle,
                  //path : "",
                  startIteration : new Date(selectedSprint.StartDate).toISOString(), 
                  endIteration : new Date(selectedSprint.EndDate).toISOString(),
                  PlanningPri : -15

                }
                const _data = CreateData(_newItem)
                
                debugger;
                AzureService.createTicketInternal(props.auth, props.project, "Initiative", JSON.stringify(_data)).then((response) => {
                    props.onSetRefresh();
                })
                console.log("2025-02-27 Save: ", _data)
              }}>
                Save
              </Button>
              </>
            }

            {selectedTicket ?
              <><hr />
                <div>
                  <Button
                    type="primary"
                    onClick={
                      (event) => {
                        props.onAddTicketToSprint(ticketId, selectedSprint.StartDate, selectedSprint.EndDate).then(
                          (response) => {
                            console.log("onAddTicketToSprint" + JSON.stringify(response, null, 4));
                            props.onSetRefresh();
                            props.handleClose();
                          }
                        )
                      }
                    }
                  >Add {selectedTicket.id}</Button>
                  &nbsp; {selectedTicket.fields[tConst.AF_TITLE]}
                </div>
              </>
              : <></>}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={props.handleClose} type="primary">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  else {
    return <></>
  }

}

export default ChartSprintHeaderMenuAdo;
